import { HoldReaction } from '@planning/app/api'
import { IHoldItem } from '@planning/rt-stores/hold/HoldItem'

export interface JourneyHoldType {
  id: number
  name?: string | null
  restrictions?: { [key: string]: HoldReaction } | null
}

export const mapToJourneyHoldType = (hold: IHoldItem): JourneyHoldType => {
  return {
    id: hold.data?.id,
    name: hold?.data?.holdType?.name,
    restrictions: hold?.data?.holdType?.restrictions,
  }
}
